/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_PROMOTION_URL, COMMON_HEADER_CONFIG} from "../config";

class CouponService {
  getAccessToken = () => localStorage.getItem("accessToken");

  // private coupon
  getListPrivateCoupon = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_PROMOTION_URL}/coupon?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        params: {
          size: 10,
          page: 1,
          ...params
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createPrivateCoupon = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_PROMOTION_URL}/coupon`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  approvePrivateCoupon = (data, id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PUT",
        url: `${API_PROMOTION_URL}/coupon/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // setting coupon
  getListCouponBudget = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_PROMOTION_URL}/coupon-budget`,
        params: {
          limit: 12,
          page: 1,
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateCouponBudget = (data, id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PUT",
        url: `${API_PROMOTION_URL}/coupon-budget/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCouponLimit = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_PROMOTION_URL}/coupon-limit`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCouponLimitSetting = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_PROMOTION_URL}/coupon-limit/setting`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createCouponLimit = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_PROMOTION_URL}/coupon-limit`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCouponByCustomer = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_PROMOTION_URL}/coupon-and-promotion?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        params: {
          size: 10,
          page: 1,
          ...params
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const couponService = new CouponService();

export default couponService;
